export const G_APP_NAME = "myPhotoPal";
export const G_APP_AUTHOR = "Simon Meglič";

export const G_MODULE_GIFT_CARD = "modGiftCard";
export const G_MODULE_PHOTO_ORDER = "modPhotoOrder";
export const G_MODULE_PHOTO_GIFT = "modPhotoGift";
export const G_MODULE_ALL = "modAll";

export const G_IMAGE_DATABASE_TYPE_BACKGROUNDS = "Backgrounds";
export const G_IMAGE_DATABASE_TYPE_PATTERNS = "Patterns";
export const G_IMAGE_DATABASE_TYPE_FRAMES = "Frames";
export const G_IMAGE_DATABASE_TYPE_STICKERS = "Stickers";

export const G_STORAGE_DEFAULT_DIR = "orders";

export const G_COPIES_SELECT_OPTIONS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "98",
  "99",
];
export const G_FILE_LOAD_CHUNK_NUM = 3;
export const G_LAST_QUANTITY_DISCOUNT_NUMBER = 1000000;
export const G_BR_SIZE = 0.03; // širina belega roba
export const G_FILL_IN_NO_CROP = -20; // koliko px je lahko slika večja od razmerja, da je tretirana kot perfect fit
export const G_FILE_COMPRESSION = 0.8; // kompresija jpg-a
export const G_TEMPLATE_SELECTION_PAGE_SIZE = 25;

export const G_LIMIT_MB_X_GB_RAM_MD_AND_DOWN = 500; // omejitev MB za sisteme brez info o ramu
export const G_LIMIT_MB_025_GB_RAM = 100;
export const G_LIMIT_MB_05_GB_RAM = 200;
export const G_LIMIT_MB_1_GB_RAM = 400;
export const G_LIMIT_MB_2_GB_RAM = 600;
export const G_LIMIT_MB_4_GB_RAM = 1000;
export const G_LIMIT_MB_8_GB_RAM = 1500;

export const G_FABRIC_JS_RESIZE_TL_ICON = "@/assets/resize-icon-tl.svg";
export const G_FABRIC_JS_RESIZE_TR_ICON = "@/assets/resize-icon-tr.svg";
export const G_FABRIC_JS_RESIZE_BR_ICON = "@/assets/resize-icon-br.svg";
export const G_FABRIC_JS_RESIZE_BL_ICON = "@/assets/resize-icon-bl.svg";
export const G_FABRIC_JS_DELETE_ICON = "@/assets/delete-icon.svg";
export const G_FABRIC_JS_ROTATE_ICON = "@/assets/rotate-icon.svg";

export const G_VUE_CROPPER_QUALITY_MIDDLE = 2; // meja faktorja za srednjo kakovost slike
export const G_VUE_CROPPER_QUALITY_LOW = 4; // meja faktorja za nizko kakovost slike
export const G_VUE_CROPPER_QUALITY_VERY_LOW = 8; // meja faktorja za zelo nizko kakovost slike